import { Component, Input } from '@angular/core';
import { CREATED, UPDATED } from '@careapp-group/core';
import { MemberDto } from '@careapp-group/ng-sdk';
import { ModelEventDto } from '@careapp-group/ng-sdk/model/modelEventDto';

@Component({
    selector: 'ca-entity-history',
    templateUrl: './entity-history-dialog.component.html',
    styleUrls: ['./entity-history-dialog.component.scss'],
    standalone: false
})
export class EntityHistoryDialogComponent {
  @Input()
  history: ModelEventDto[];
  @Input()
  loading: boolean;

  @Input()
  members: { [id: string]: MemberDto };

  CREATED = CREATED;
  UPDATED = UPDATED;

  constructor() {}
}
